"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var errorComponent_1 = require("./errorComponent");
var govMointor_1 = require("./govMointor");
exports.govMointor = govMointor_1.default;
require("./longtask");
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // 更新 state 使下一次渲染能够显示降级后的 UI
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // 你同样可以将错误日志上报给服务器
        window.__bl && window.__bl.error && window.__bl.error(error, errorInfo); //原信息上报一份
        window.__bl && window.__bl.error && window.__bl.error(new Error(this.props.errorMsg), errorInfo);
        govMointor_1.default.sum(this.props.blankScreenMsg);
    };
    ErrorBoundary.prototype.componentDidMount = function () {
        if (this.props.autoTouchEvent && this.props.eventName) {
            dispatchEvent(this.props.eventName);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var ErrorWarp = this.props.errorComponent;
        var opts = {
            cls: this.props.cls,
            src: this.props.blankImage,
            style: this.props.style,
        };
        if (this.state.hasError) {
            return React.createElement(ErrorWarp, __assign({}, opts));
        }
        return this.props.children;
    };
    ErrorBoundary.defaultProps = { eventName: "blank_page_event", autoTouchEvent: true, errorComponent: errorComponent_1.default, errorMsg: "react crash", blankScreenMsg: "blank_screen", noBlankScreen: "no_blank_screen" };
    return ErrorBoundary;
}(React.Component));
var dispatchEvent = function (eventName) {
    var evt = document.createEvent('Event');
    evt.initEvent(eventName, true, true);
    window.dispatchEvent(evt);
};
exports.dispatchEvent = dispatchEvent;
exports.default = ErrorBoundary;
